export default "__VITE_ASSET__C7qo7P9m__"